export default {
  serverURL: "https://api-landing.dayo.africa",
  // serverURL: "http://localhost:12029",
  apiVersion: "api/v1/",
  secretPass: "v(LDfK]D:Kn7DDBg_mBQbGF7bJd=\b6G@, !+E?7f5!-98Vxke",
};
